import { OnSuccessCallback, useCustomMutation } from './index';

import { QueryError, QueryKeys } from '../queries';

import Config from '../../config';
import { METHODS } from '../constants';
import { Currency } from '../../administration/clientAdministrationPage/types';

export type CurrencyMutationVariable = Currency;

export const useCreateCurrency = (onSuccess?: OnSuccessCallback<Response, CurrencyMutationVariable>) =>
  useCustomMutation<Response, QueryError, CurrencyMutationVariable>({
    handleData: body => ({
      url: Config.endpoints.CREATE_CURRENCY,
      method: METHODS.POST,
      body,
    }),
    invalidateKey: query => [QueryKeys.currencies.AdminCurrencies].includes(query.queryKey[0] as string),
    errorMessage: 'Creating currency failed',
    successMessage: 'Currency created successfully',
    onSuccess,
  });

export const useUpdateCurrency = (onSuccess?: OnSuccessCallback<Response, CurrencyMutationVariable>) =>
  useCustomMutation<Response, QueryError, CurrencyMutationVariable>({
    handleData: body => ({
      url: Config.endpoints.UPDATE_CURRENCY,
      method: METHODS.PUT,
      body,
    }),
    invalidateKey: query => [QueryKeys.currencies.AdminCurrencies].includes(query.queryKey[0] as string),
    errorMessage: 'Updating currency failed',
    successMessage: 'Currency updated successfully',
    onSuccess,
  });

export const useDeleteCurrency = (onSuccess?: OnSuccessCallback<Response, Pick<CurrencyMutationVariable, 'currencyCode'>>) =>
  useCustomMutation<Response, QueryError, Pick<CurrencyMutationVariable, 'currencyCode'>>({
    handleData: ({ currencyCode }) => ({
      url: Config.endpoints.DELETE_CURRENCY,
      method: METHODS.DELETE,
      body: { currencyCode },
    }),
    invalidateKey: query => [QueryKeys.currencies.AdminCurrencies].includes(query.queryKey[0] as string),
    errorMessage: 'Removing currency failed',
    successMessage: 'Currency removed successfully',
    onSuccess,
  });
